import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/timeline/timeline-item.component.js'

const tagName = 'dap-ds-timeline-item'

/**
 * `dap-ds-timeline-item`
 * @summary A timeline is a graphical representation of a series of events.
 * @element dap-ds-timeline-item
 * @title - Timeline item
 * @group timeline
 *
 * @slot - The default slot for the item content.
 *
 * @csspart base - The main timeline item container.
 * @csspart connector - The connector element between two timeline items.
 * @csspart content - The content of the timeline item.
 *
 * @cssproperty --dds-timeline-position - Position of the timeline dot (default: 28px)
 * @cssproperty --dds-timeline-connector-width - Width of the timeline connector line (default: 1px)
 * @cssproperty --dds-timeline-connector-left-position - Left position of the timeline connector (default: 5.5px)
 * @cssproperty --dds-timeline-dot-size - Size of the timeline dot (default: var(--dds-spacing-300))
 * @cssproperty --dds-timeline-item-margin-bottom - Bottom margin of timeline items (default: var(--dds-spacing-200))
 * @cssproperty --dds-timeline-item-padding-left - Left padding of timeline items (default: var(--dds-spacing-400))
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTimelineItem',
})

export default reactWrapper
